export const environment = {
  production: true,
  //apiUrl: 'https://localhost:44313',
  apiUrl: 'https://ofekpoint.net-watch.it',
  //apiUrl: 'https://caesarea-safety.ofekpoint.com',
};
